// defined in https://docs.google.com/spreadsheets/d/1Ac4U0drJKf0woS3qNsE0KJRlPjePaj0P07BLYNOlkK0/edit#gid=435350312
// latest update 14.6.23

import TRANSLATION_KEYS from '@/js/components/HubSpot/hubspot-translation-keys.js'

export const stepConfig = [
  // Initial Step for Contact
  {
    id: 'co',
    translationKey: TRANSLATION_KEYS.CONTACT,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
        value: 'wagu',
      },
      // {
      //   requireLogin: false,
      //   translationKey: TRANSLATION_KEYS.BECOME_TRADING_PARTNER,
      //   value: 'betp',
      //   formName: 'BecomeTradingPartnerForm',
      // },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ORDER,
        value: 'ordr',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PRODUCT_REQUEST_TECHNICAL_SUPPORT,
        value: 'prts',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAYMENT_TRANSACTIONS,
        value: 'patr',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.FEEDBACK,
        value: 'fdbk',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.MASTER_DATA_ADDRESSES,
        value: 'mdad',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'OtherForm',
      },
    ],
  },
  // Warranty/Guarantee Steps
  {
    requireLogin: false,
    id: 'wagu',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_CLAIM,
        value: 'wacl',
        formName: 'WarrantyGuaranteeGuaranteeForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          'service-warranty-components': '',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.REQUEST_BATTERIES_CHARGERS,
        value: 'rebc',
        formName: 'WarrantyGuaranteeBatteryChargerForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          'service-warranty-battery': '',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.APPLICATION_FOR_MOTORS,
        value: 'apmo',
        formName: 'WarrantyGuaranteeMotorForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          engineComplaintFormUrl: '',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPLAINT_SPARE_PARTS_DELIVERY,
        value: 'cspd',
        formName: 'WarrantyGuaranteeSparepartDeliveryForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          'service-warranty-return': '',
        },
      },
    ],
  },
  // Missing component Steps
  {
    requireLogin: false,
    id: 'wanf',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.BIKE_SOLD_TO_CUSTOMER,
        value: 'bscu',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.BIKE_SOLD_NOT_TO_CUSTOMER,
        value: 'bnsc',
      },
    ],
  },
  // Sold to Customer
  {
    requireLogin: false,
    id: 'bscu',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
        value: 'panfa',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
        value: 'trdaa',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
        value: 'asqua',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_CLAIM,
        value: 'wacl1a',
        formName: 'WarrantyGuaranteeWarrantyClaimForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
        value: 'redea',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PRODUCT_LIABILITY,
        value: 'prlia',
        formName: 'WarrantyGuaranteeProductLiabilityForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othra',
        formName: 'WarrantyGuaranteeOtherForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'panfa',
    translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.FRAME,
        value: 'frmea',
        formName: 'WarrantyGuaranteePartNotFoundFrameForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER_COMPONENT,
        value: 'otcoa',
        formName: 'WarrantyGuaranteePartNotFoundOtherComponentForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'trdaa',
    translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'padaa',
        formName: 'WarrantyGuaranteeTransportPaintDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PACKAGING_DAMAGE,
        value: 'pkdaa',
        formName: 'WarrantyGuaranteeTransportPackagingDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'codaa',
        formName: 'WarrantyGuaranteeTransportComponentDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WHOLE_BIKE,
        value: 'whbia',
        formName: 'WarrantyGuaranteeTransportWholeBikeDamageForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'asqua',
    translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'pada1a',
        formName: 'WarrantyGuaranteeAssemblyPaintDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'coda1a',
        formName: 'WarrantyGuaranteeAssemblyComponentDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_MOUNTED_INCORRECTLY,
        value: 'comia',
        formName: 'WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WRONG_COMPONENT_MOUNTED,
        value: 'wrcma',
        formName: 'WarrantyGuaranteeAssemblyWrongComponentForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'redea',
    translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_MISSING_ON_DELIVERY,
        value: 'pmoda',
        formName: 'WarrantyGuaranteeReplacementPartMissingForm',
        showAdditionalFields: true,
        jumpToPageKeys: {
          'service-warranty-return': '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASKING_FOR_DELIVERY_DATE,
        value: 'askda',
        formName: 'WarrantyGuaranteeReplacementAskingDeliveryDateForm',
        showAdditionalFields: true,
        jumpToPageKeys: {
          overview: '_blank',
        },
      },
    ],
  },
  // Sold not to Customer
  {
    requireLogin: false,
    id: 'bnsc',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
        value: 'panf',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
        value: 'trda',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
        value: 'asqu',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_CLAIM,
        value: 'wacl1',
        formName: 'WarrantyGuaranteeWarrantyClaimForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
        value: 'rede',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PRODUCT_LIABILITY,
        value: 'prli',
        formName: 'WarrantyGuaranteeProductLiabilityForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'WarrantyGuaranteeOtherForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'panf',
    translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.FRAME,
        value: 'frme',
        formName: 'WarrantyGuaranteePartNotFoundFrameForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER_COMPONENT,
        value: 'otco',
        formName: 'WarrantyGuaranteePartNotFoundOtherComponentForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'trda',
    translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'pada',
        formName: 'WarrantyGuaranteeTransportPaintDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PACKAGING_DAMAGE,
        value: 'pkda',
        formName: 'WarrantyGuaranteeTransportPackagingDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'coda',
        formName: 'WarrantyGuaranteeTransportComponentDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WHOLE_BIKE,
        value: 'whbi',
        formName: 'WarrantyGuaranteeTransportWholeBikeDamageForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'asqu',
    translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'pada1',
        formName: 'WarrantyGuaranteeAssemblyPaintDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'coda1',
        formName: 'WarrantyGuaranteeAssemblyComponentDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_MOUNTED_INCORRECTLY,
        value: 'comi',
        formName: 'WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WRONG_COMPONENT_MOUNTED,
        value: 'wrcm',
        formName: 'WarrantyGuaranteeAssemblyWrongComponentForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'rede',
    translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_MISSING_ON_DELIVERY,
        value: 'pmod',
        formName: 'WarrantyGuaranteeReplacementPartMissingForm',
        jumpToPageKeys: {
          'service-warranty-return': '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASKING_FOR_DELIVERY_DATE,
        value: 'askd',
        formName: 'WarrantyGuaranteeReplacementAskingDeliveryDateForm',
        jumpToPageKeys: {
          overview: '_blank',
        },
      },
    ],
  },
  // Order Steps
  {
    requireLogin: false,
    id: 'ordr',
    translationKey: TRANSLATION_KEYS.ORDER,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ORDER_REQUEST_BIKE,
        value: 'rebi',
        formName: 'OrderRequestBikeForm',
        jumpToPageKeys: {
          BIKES: '_blank',
          'quick-buy': '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ORDER_REQUEST_SPARE_PART_ACCESSORIES,
        value: 'resp',
        formName: 'OrderRequestSparePartAccessoriesForm',
        jumpToPageKeys: {
          SERVICE: '_blank',
          'quick-buy': '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.SHIPPING_STATUS_BIKE,
        value: 'shsb',
        formName: 'OrderShippingStatusBikeForm',
        jumpToPageKeys: {
          tracking: '_blank',
          backorder: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ORDER_CHANGE,
        value: 'orch',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.BACKORDER,
        value: 'bkor',
        formName: 'OrderBackorderForm',
        jumpToPageKeys: {
          backorder: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'OrderOtherForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'orch',
    translationKey: TRANSLATION_KEYS.ORDER_CHANGE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CANCELLATION_REQUEST,
        value: 'care',
        formName: 'OrderChangeCancellationRequestForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.EXCHANGE_ITEM,
        value: 'chit',
        formName: 'OrderChangeExchangeItemForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_DELIVERY_DATE,
        value: 'chdd',
        formName: 'OrderChangeDeliveryDateForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_PAYMENT_TERM,
        value: 'chpt',
        formName: 'OrderChangePaymentTermForm',
        jumpToPageKeys: {
          openItems: '_blank',
        },
      },
    ],
  },
  // Product Request / Tech Support Steps
  {
    requireLogin: false,
    id: 'prts',
    translationKey: TRANSLATION_KEYS.PRODUCT_REQUEST_TECHNICAL_SUPPORT,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.AVAILABILITY_BIKE,
        value: 'avbi',
        formName: 'ProductRequestAvailabilityBikeForm',
        jumpToPageKeys: {
          BIKES: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.AVAILABILITY_SPARE_PART,
        value: 'avsp',
        formName: 'ProductRequestAvailabilitySparePartForm',
        jumpToPageKeys: {
          SERVICE: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.EBIKE_SYSTEMS,
        value: 'ebsy',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'ProductRequestOtherForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'ebsy',
    translationKey: TRANSLATION_KEYS.EBIKE_SYSTEMS,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.IMPULSE,
        value: 'impl',
        formName: 'EbikeSystemsImpulseForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.BOSCH,
        value: 'bosh',
        formName: 'EbikeSystemsBoschForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.SHIMANO,
        value: 'shim',
        formName: 'EbikeSystemsShimanoForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.FAZUA,
        value: 'fazu',
        formName: 'EbikeSystemsFazuaForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.GROOVE,
        value: 'grve',
        formName: 'EbikeSystemsGrooveForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CONTINENTAL,
        value: 'cont',
        formName: 'EbikeSystemsContinentalForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.XION_NEODRIVE,
        value: 'xine',
        formName: 'EbikeSystemsXionNeodriveForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'impl',
    translationKey: TRANSLATION_KEYS.IMPULSE,
  },
  {
    requireLogin: false,
    id: 'bosh',
    translationKey: TRANSLATION_KEYS.BOSCH,
  },
  {
    requireLogin: false,
    id: 'shim',
    translationKey: TRANSLATION_KEYS.SHIMANO,
  },
  {
    requireLogin: false,
    id: 'fazu',
    translationKey: TRANSLATION_KEYS.FAZUA,
  },
  // Payment Steps
  {
    requireLogin: false,
    id: 'patr',
    translationKey: TRANSLATION_KEYS.PAYMENT_TRANSACTIONS,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.INVOICE_CORRECTION,
        value: 'inco',
        formName: 'PaymentTransactionsInvoiceCorrectionForm',
        jumpToPageKeys: {
          downloadDocuments: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CREDITS,
        value: 'cred',
        formName: 'PaymentTransactionsCreditsForm',
        jumpToPageKeys: {
          downloadDocuments: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAYMENT_AGREEMENT,
        value: 'paag',
        formName: 'PaymentTransactionsPaymentAgreementForm',
        jumpToPageKeys: {
          downloadDocuments: '_blank',
          openItems: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PROOF_OF_PAYMENT,
        value: 'prop',
        formName: 'PaymentTransactionsProofOfPaymentForm',
        jumpToPageKeys: {
          downloadDocuments: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'PaymentTransactionsOtherForm',
        jumpToPageKeys: {
          downloadDocuments: '_blank',
        },
      },
    ],
  },
  // Feedback Steps
  {
    requireLogin: false,
    id: 'fdbk',
    translationKey: TRANSLATION_KEYS.FEEDBACK,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.DEALER_PORTAL,
        value: 'dlpr',
        formName: 'FeedbackDealerportalForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PROCESS,
        value: 'prcs',
        formName: 'FeedbackProcessForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.SAP,
        value: 'sapf',
        formName: 'FeedbackSAPForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.SERVICE,
        value: 'srvc',
        formName: 'FeedbackServiceForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PRODUCT,
        value: 'prdc',
        formName: 'FeedbackProductForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.DELIVERY,
        value: 'dlvr',
        formName: 'FeedbackDeliveryForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.TELEPHONE_CONTACT,
        value: 'tlco',
        formName: 'FeedbackTelephoneForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'FeedbackOtherForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'dlpr',
    translationKey: TRANSLATION_KEYS.DEALER_PORTAL,
  },
  {
    requireLogin: false,
    id: 'prcs',
    translationKey: TRANSLATION_KEYS.PROCESS,
  },
  {
    requireLogin: false,
    id: 'sapf',
    translationKey: TRANSLATION_KEYS.SAP,
  },
  {
    requireLogin: false,
    id: 'srvc',
    translationKey: TRANSLATION_KEYS.SERVICE,
  },
  {
    requireLogin: false,
    id: 'prdc',
    translationKey: TRANSLATION_KEYS.PRODUCT,
  },
  {
    requireLogin: false,
    id: 'dlvr',
    translationKey: TRANSLATION_KEYS.DELIVERY,
  },
  // Master Data and Addresses Steps
  {
    requireLogin: false,
    id: 'mdad',
    translationKey: TRANSLATION_KEYS.MASTER_DATA_ADDRESSES,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_OF_NAME,
        value: 'chna',
        formName: 'MasterDataAddressesChangeNameForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_OF_ADDRESS,
        value: 'chad',
        formName: 'MasterDataAddressesChangeAddressForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          addresses: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_OF_DELIVERY_ADDRESS,
        value: 'chda',
        formName: 'MasterDataAddressesChangeDeliveryAddressForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          addresses: '_blank',
        },
      },
    ],
  },
]

export const stepConfigUA = [
  // Initial Step for Contact
  {
    id: 'co',
    translationKey: TRANSLATION_KEYS.CONTACT,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
        value: 'wagu',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.MASTER_DATA_ADDRESSES,
        value: 'mdad',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'OtherForm',
      },
    ],
  },
  // Warranty/Guarantee Steps
  {
    requireLogin: false,
    id: 'wagu',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_CLAIM,
        value: 'wacl',
        formName: 'WarrantyGuaranteeGuaranteeForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          'service-warranty-components': '',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPLAINT_SPARE_PARTS_DELIVERY,
        value: 'cspd',
        formName: 'WarrantyGuaranteeSparepartDeliveryForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          'service-warranty-return': '',
        },
      },
    ],
  },
  // Missing component Steps
  {
    requireLogin: false,
    id: 'wanf',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.BIKE_SOLD_TO_CUSTOMER,
        value: 'bscu',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.BIKE_SOLD_NOT_TO_CUSTOMER,
        value: 'bnsc',
      },
    ],
  },
  // Sold to Customer
  {
    requireLogin: false,
    id: 'bscu',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
        value: 'panfa',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
        value: 'trdaa',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
        value: 'asqua',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_CLAIM,
        value: 'wacl1a',
        formName: 'WarrantyGuaranteeWarrantyClaimForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
        value: 'redea',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PRODUCT_LIABILITY,
        value: 'prlia',
        formName: 'WarrantyGuaranteeProductLiabilityForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othra',
        formName: 'WarrantyGuaranteeOtherForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'panfa',
    translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.FRAME,
        value: 'frmea',
        formName: 'WarrantyGuaranteePartNotFoundFrameForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER_COMPONENT,
        value: 'otcoa',
        formName: 'WarrantyGuaranteePartNotFoundOtherComponentForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'trdaa',
    translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'padaa',
        formName: 'WarrantyGuaranteeTransportPaintDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PACKAGING_DAMAGE,
        value: 'pkdaa',
        formName: 'WarrantyGuaranteeTransportPackagingDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'codaa',
        formName: 'WarrantyGuaranteeTransportComponentDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WHOLE_BIKE,
        value: 'whbia',
        formName: 'WarrantyGuaranteeTransportWholeBikeDamageForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'asqua',
    translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'pada1a',
        formName: 'WarrantyGuaranteeAssemblyPaintDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'coda1a',
        formName: 'WarrantyGuaranteeAssemblyComponentDamageForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_MOUNTED_INCORRECTLY,
        value: 'comia',
        formName: 'WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm',
        showAdditionalFields: true,
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WRONG_COMPONENT_MOUNTED,
        value: 'wrcma',
        formName: 'WarrantyGuaranteeAssemblyWrongComponentForm',
        showAdditionalFields: true,
      },
    ],
  },
  {
    requireLogin: false,
    id: 'redea',
    translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_MISSING_ON_DELIVERY,
        value: 'pmoda',
        formName: 'WarrantyGuaranteeReplacementPartMissingForm',
        showAdditionalFields: true,
        jumpToPageKeys: {
          'service-warranty-return': '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASKING_FOR_DELIVERY_DATE,
        value: 'askda',
        formName: 'WarrantyGuaranteeReplacementAskingDeliveryDateForm',
        showAdditionalFields: true,
        jumpToPageKeys: {
          overview: '_blank',
        },
      },
    ],
  },
  // Sold not to Customer
  {
    requireLogin: false,
    id: 'bnsc',
    translationKey: TRANSLATION_KEYS.WARRANTY_GUARANTEE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
        value: 'panf',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
        value: 'trda',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
        value: 'asqu',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WARRANTY_CLAIM,
        value: 'wacl1',
        formName: 'WarrantyGuaranteeWarrantyClaimForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
        value: 'rede',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PRODUCT_LIABILITY,
        value: 'prli',
        formName: 'WarrantyGuaranteeProductLiabilityForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER,
        value: 'othr',
        formName: 'WarrantyGuaranteeOtherForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'panf',
    translationKey: TRANSLATION_KEYS.PART_NOT_FOUND,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.FRAME,
        value: 'frme',
        formName: 'WarrantyGuaranteePartNotFoundFrameForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.OTHER_COMPONENT,
        value: 'otco',
        formName: 'WarrantyGuaranteePartNotFoundOtherComponentForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'trda',
    translationKey: TRANSLATION_KEYS.TRANSPORT_DAMAGE,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'pada',
        formName: 'WarrantyGuaranteeTransportPaintDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PACKAGING_DAMAGE,
        value: 'pkda',
        formName: 'WarrantyGuaranteeTransportPackagingDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'coda',
        formName: 'WarrantyGuaranteeTransportComponentDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WHOLE_BIKE,
        value: 'whbi',
        formName: 'WarrantyGuaranteeTransportWholeBikeDamageForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'asqu',
    translationKey: TRANSLATION_KEYS.ASSEMBLY_QUALITY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PAINT_DAMAGE,
        value: 'pada1',
        formName: 'WarrantyGuaranteeAssemblyPaintDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_DAMAGE,
        value: 'coda1',
        formName: 'WarrantyGuaranteeAssemblyComponentDamageForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.COMPONENT_MOUNTED_INCORRECTLY,
        value: 'comi',
        formName: 'WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.WRONG_COMPONENT_MOUNTED,
        value: 'wrcm',
        formName: 'WarrantyGuaranteeAssemblyWrongComponentForm',
      },
    ],
  },
  {
    requireLogin: false,
    id: 'rede',
    translationKey: TRANSLATION_KEYS.REPLACEMENT_DELIVERY,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.PART_MISSING_ON_DELIVERY,
        value: 'pmod',
        formName: 'WarrantyGuaranteeReplacementPartMissingForm',
        jumpToPageKeys: {
          'service-warranty-return': '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.ASKING_FOR_DELIVERY_DATE,
        value: 'askd',
        formName: 'WarrantyGuaranteeReplacementAskingDeliveryDateForm',
        jumpToPageKeys: {
          overview: '_blank',
        },
      },
    ],
  },
  // Master Data and Addresses Steps
  {
    requireLogin: false,
    id: 'mdad',
    translationKey: TRANSLATION_KEYS.MASTER_DATA_ADDRESSES,
    options: [
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_OF_NAME,
        value: 'chna',
        formName: 'MasterDataAddressesChangeNameForm',
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_OF_ADDRESS,
        value: 'chad',
        formName: 'MasterDataAddressesChangeAddressForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          addresses: '_blank',
        },
      },
      {
        requireLogin: false,
        translationKey: TRANSLATION_KEYS.CHANGE_OF_DELIVERY_ADDRESS,
        value: 'chda',
        formName: 'MasterDataAddressesChangeDeliveryAddressForm',
        hideSubmitButton: true,
        jumpToPageKeys: {
          addresses: '_blank',
        },
      },
    ],
  },
]

export default stepConfig
